export default {"src":"/_next/static/media/shallots.61c2b842.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};